import { render, staticRenderFns } from "./HomeFofo.vue?vue&type=template&id=7638cc82&scoped=true"
import script from "./HomeFofo.vue?vue&type=script&lang=js"
export * from "./HomeFofo.vue?vue&type=script&lang=js"
import style0 from "./HomeFofo.vue?vue&type=style&index=0&id=7638cc82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7638cc82",
  null
  
)

export default component.exports